import PropTypes from "prop-types";
import "./styles.css";
import Select from "../../Inputs/Select";
import RadioList from "../../Inputs/RadioList";
import {
  OwnerOccupationOptions,
  YesNoOptions,
  PropertyCurrentConditionOptions,
  EstimatedValueOptions,
} from "../../../Leadform/options";
import { useLeadForm } from "../../../context/leadform";

function AdditionalInfoStep({}) {
  return (
    <div className="Step AdditionalInfoStep">
      <h2>Help us find the right cash buyers for your property</h2>
      <p>
        A few quick details to help us compare the buyers most suited to your
        property.
      </p>

      <div className="PropertySummary">
        <RadioList
          label="Is the property inherited?"
          inline={true}
          options={YesNoOptions}
          statekey="inherited"
        />

        <RadioList
          label="What condition is the property in?"
          inline={true}
          options={PropertyCurrentConditionOptions}
          statekey="property_condition"
        />

        <RadioList
          label="Any serious issues with the property?"
          inline={true}
          options={YesNoOptions}
          statekey="serious_issues"
        />

        <RadioList
          label="Is the property currently occupied?"
          inline={true}
          options={OwnerOccupationOptions}
          statekey="occupation_status"
        />

        <Select
          label="Estimated Value"
          inline={true}
          options={Array.from({ length: 199 }, (v, k) => {
            return {
              value: (10000 + k * 5000).toString(),
              label: `£${(10000 + k * 5000).toLocaleString()}`,
            };
          })}
          statekey="user_estimated_value"
        />
      </div>
    </div>
  );
}

export default AdditionalInfoStep;

AdditionalInfoStep.propTypes = {};
